const $ = kendo.jQuery

function getGridColumns(typeNumCol) {
  const columns = [
    {
      field: 'Period',
      template: '#=data.Period || kendo.toString(data.PeriodEnd, "MMM-yy")#',
      title: 'Period',
      hidden: false,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: left;',
      },
    },
  ]

  ;[...(typeNumCol || [])].forEach(function(element) {
    const column = {
      field: element.field,
      title: element.typeNum,
      hidden: !element.visible,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: right;',
      },
      format: '{0:N0}',
    }

    switch (column.field) {
      case 'ColumnC':
        column.attributes['class'] = 'hedgeCDrillDown'
        break
      case 'ColumnNC':
        column.attributes['class'] = 'hedgeNCDrillDown'
        break
      case 'Adjustment':
        column.attributes['class'] = 'adjustmentDrillDown'
        break
      case 'Niveau':
      case 'BudgetRate':
      case 'ActualRate':
        column.format = '{0:N4}'
        break
    }

    columns.push(column)
  })

  return [...columns]
}

function renderGrid($container, options, renderLocation) {
  return new Promise(function(resolve, reject) {
    const actionName = renderLocation == 'report' ? 'DataSource' : 'DataSourceComponent'
    const controllerName = 'ExposureReportV4'
    const dataSourceUrl = `/api/report/${controllerName}/${actionName}`

    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const {data, typeNumCols} = response

        const grid = $container
          .empty()
          .kendoGrid({
            editable: false,
            scrollable: false,
            dataSource: {
              data: data,
              schema: {
                model: {
                  id: 'Id',
                  fields: {
                    DivisionId: {
                      type: 'number',
                    },
                    Division: {
                      type: 'string',
                    },
                    PeriodStart: {
                      type: 'date',
                    },
                    PeriodEnd: {
                      type: 'date',
                    },
                    Period: {
                      type: 'string',
                    },
                  },
                },
              },
            },
            dataBound: function(e) {
              if (renderLocation === 'dashboard') {
                const items = e.sender.dataSource.data().length
                if (items == 0) {
                  e.sender.element.closest('.component').remove()
                }
                if (items > 25) {
                  e.sender.element.closest('.component').prepend('<div class="page-break"/>')
                }
              }

              const $grandTotal = e.sender.element.find('tr:last')
              $grandTotal
                .addClass('k-grid-header')
                .removeClass('k-alt')
                .find('td')
                .addClass('k-header')
              $grandTotal.find('td').removeClass('hedgeNCDrillDown hedgeCDrillDown')

              resolve(grid)
            },
            filterable: false,
            sortable: false,
            pageable: false,
            columns: getGridColumns(typeNumCols),
          })
          .data('kendoGrid')

        // if (renderLocation === 'report') {
        //   kgAutoheight.enableResize($container.data('kendoGrid'))
        // }
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

export default {
  render: function($container, options, location = 'dashboard') {
    return renderGrid($container, options, location)
  },
}
